import { render, staticRenderFns } from "./NotificationTemplate.vue?vue&type=template&id=45e17c98&"
import script from "./NotificationTemplate.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTemplate.vue?vue&type=style&index=0&id=45e17c98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports